<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;margin-top: 1rem;" class="fontMS700 font-45 colorPrincipal">
            JORGE BASADRE <br>
            Y LA VOCACIÓN<br>
            BIBLIOTECARIA EN EL PERÚ<br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio23/jorge-basadre">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio23/jorge-basadre">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio23/jorge-basadre">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio23/BASADRE-000.jpg">
    
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    JORGE BASADRE ES RECONOCIDO COMO UNO DE LOS HISTORIADORES MÁS
                    DESTACADOS DE NUESTRA HISTORIA REPUBLICANA, ADEMÁS DE CONTAR CON
                    UNA NOTABLE TRAYECTORIA AL SERVICIO DEL ESTADO COMO DOCENTE
                    UNIVERSITARIO, DIRECTOR DE LA BIBLIOTECA NACIONAL Y MINISTRO DE
                    EDUCACIÓN.
                    <br><br>
                </p>
            </div>
            <div class="row">
                <!-- <div class="col-sm-6">
                    <img class="pd-10" width="100%"
                        src="/assets/images/micrositio/micrositio23/BASADRE-001.jpg">

                    <p class="fontMS100Italic font-20 text-gris" style="font-weight: bold;">
                        <br>
                        Baldomero Pestana. Retrato de Jorge Basadre, 1964
                        Repositorio institucional PUCP
                    </p>
                </div> -->
                <div class="col-sm-12">
                    <p class="fontMS100 text-justify font-24">
                        
                        Al inicio de la década de 1930, ya se 
                        desempeñaba como profesor en la
                        Universidad Nacional Mayor de San Marcos, 
                        donde también cumplió una destacada labor 
                        como director de su Biblioteca Central. Pero, 
                        en 1931, el presidente Sánchez Cerro clausura 
                        la universidad, por lo cual, Basadre viaja al 
                        extranjero, primero a Estados Unidos para 
                        especializarse en organización de bibliotecas. 
                        Luego, sigue cursos en la Universidad de Berlín 
                        sobre historia y realiza investigaciones en los 
                        archivos de la Universidad de Sevilla, España. 
                        Regresa al país cuando la universidad reabre 
                        sus puertas en 1935.
                        
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <p class="fontMS100 text-justify font-24">
                        <br>
                        Manuel Prado Ugarteche asume la presidencia en 1939 y, unos años más tarde, en 1943, nombra
                        a Basadre como director de la Biblioteca Nacional, una posición importante y, a la vez, difícil, pues se 
                        le encargó su reconstrucción tras el incendio que causó la extinción y el deterioro de importantes 
                        obras bibliográficas y documentales. Basadre fue consciente de la ardua tarea que le esperaba 
                        cuando asumió la dirección de la Biblioteca luego de su destrucción, evento que calificó como el 
                        más lamentable que le sucedió al Perú en el siglo XX. A partir de este momento dirigió todos sus 
                        esfuerzos a rescatar los restos de la antigua Biblioteca, supervisar la construcción de un nuevo 
                        edificio y dirigir la reconstrucción de las nuevas colecciones. 
                        <br><br>
                    </p>
                    <p class="fontMS100 text-justify font-24">
                        Cuando José Luis Bustamante y Rivero fue elegido presidente en 1945, convoca a Basadre para 
                        ser ministro de Educación, por lo que deja temporalmente la dirección de la Biblioteca Nacional, 
                        y a la que regresaría meses después. Al finalizar su gestión en 1948, Basadre había logrado reconstruir 
                        gran parte de la colección perdida, dotó a la Biblioteca de una infraestructura moderna y funcional 
                        con espacios equipados para el trabajo técnico bibliotecario y salas de lectura para diversos públicos. 
                        Jorge Basadre creía en la función de las bibliotecas como espacios democratizadores para el acceso a 
                        la educación y la cultura. Un derecho del cual no podían estar privados los niños, jóvenes y adultos.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <p style="line-height: 130%;margin-bottom: 0%;margin-top:5%" class="fontMS700 colorPrincipal2 font-40">
                            VOCACIÓN
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada_a.png">
                    </div>
                </div>
                <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS100 colorPrincipal2 font-40">
                    BIBLIOTECARIA
                </p>
                <div class="c100">
                    <img class="LineSubsec_Izq" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada_a.png">
                </div>
                <p class="fontMS500 text-center font-24 text-white">
                    <br><br>
                    LAS BIBLIOTECAS FUERON PARTE ESENCIAL DE LA VIDA DE JORGE BASADRE. SU FORMACIÓN COMO LECTOR E INVESTIGADOR 
                    TRANSCURRIÓ EN LAS BIBLIOTECAS, Y, POSTERIORMENTE, SU COMPROMISO CON UN PAÍS DEMOCRÁTICO SE REFLEJÓ EN SU 
                    LABOR PROFESIONAL COMO DIRECTOR DE LA BIBLIOTECA NACIONAL DEL PERÚ. 
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-6">
                        <img class="pd-10" width="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-002.jpg">
                        <p class="fontMS100Italic text-white font-20 pd-10">
                            <br>
                            Recuerdos de un bibliotecario peruano:
                            1919-1930; 1930-1932; 1935-1942; 1943-1948;
                            1956-1958
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-white font-24">
                            <br><br><br>
                            Su vínculo con la Biblioteca Nacional 
                            comienza en 1914, cuando el director de ese 
                            entonces, Luis Ulloa, le otorga el permiso para 
                            estudiar en su despacho, donde conoce a varios 
                            intelectuales. En 1920 es convocado por Alejandro 
                            Deustua, posterior director de la Biblioteca, para 
                            registrar en fichas las obras editadas en el siglo XX, 
                            las que servirían de guía a los lectores. En su libro 
                            <span class="fontMS100Italic">Recuerdos de un bibliotecario peruano</span> 
                            relata que no encontró un catálogo de libros. Al respecto, manifestó que «el orden 
                            de los libros en todas las secciones era por tamaños, de 
                            acuerdo con su fecha de ingreso. Conocer su ubicación era 
                            privilegio reservado a la experiencia y al interés 
                            de empleados antiguos». 
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-white text-justify font-24">
                            <br>
                            En 1923, fue convocado por su maestro Pedro Zulen para trabajar en la Biblioteca de la Universidad de 
                            San Marcos como redactor del Boletín Bibliográfico (1923-1925) y como supervisor del turno nocturno (1924). 
                            En 1930, Basadre se convierte en el director de la biblioteca de la universidad. En 1931, obtiene la beca 
                            de la Fundación Carnegie y se traslada a los Estados Unidos para estudiar organización de bibliotecas. 
                            Años después, viaja a España y Alemania en donde visita bibliotecas y archivos.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-white text-justify font-24">
                            En 1935, Jorge Basadre regresó de Europa para hacerse cargo de la cátedra de historia y de la dirección de la biblioteca 
                            de la Universidad de San Marcos. En la biblioteca organizó las secciones de Ingresos, Catalogación y Clasificación, 
                            Circulación e Informes, Conservación del local y materiales. 
                            <br><br>
                        </p>
                        <p class="fontMS100 text-white text-justify font-24">
                            En junio de 1943, Basadre fue designado director de la Biblioteca Nacional en reemplazo de Carlos Romero, quien estuvo a cargo 
                            de dicha institución cuando ocurrió el trágico incendio de su local institucional en el Centro Histórico de Lima. 
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <a href="http://hdl.handle.net/20.500.14428/79635" target="_blank" style="color: black;">
                            <img width="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-003.jpg">
                        </a>
                        <p class="fontMS100Italic text-white font-20 pd-10">
                            <br>
                            Foto de la Generación del Bicentenario en revista Mundial, 28 de julio 1921
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            RECONSTRUCCIÓN Y CREACIÓN
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS300 text-center colorPrincipal font-40">
                    DE LA TERCERA BIBLIOTECA NACIONAL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24">
                            DESPUÉS DEL INCENDIO DEL 10 DE MAYO DE 1943 SE LE ENCOMIENDA A JORGE 
                            BASADRE LA RECUPERACIÓN Y RECONSTRUCCIÓN DE LA BIBLIOTECA NACIONAL. 
                            ÉL ACEPTA EL CARGO DE DIRECTOR CON ALGUNAS CONDICIONES, ENTRE LAS 
                            CUALES ESTABA EL RESTABLECIMIENTO SOBRE LA BASE DE UN PLAN TÉCNICO, 
                            AMPLIA AUTORIDAD Y LA CREACIÓN DE UNA ESCUELA DE BIBLIOTECARIOS.
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-24">
                            La rehabilitación de la Biblioteca Nacional del
                            Perú de 1943 a 1947 resultó una tarea titánica.
                            Se inició rescatando el material que resistió al
                            incendio. Luego, se restauró la colección
                            perdida a través de donaciones, compras y
                            reproducciones. Se impuso la tarea de
                            encontrar en el país o en el extranjero material
                            bibliográfico del Perú o sobre el Perú. Se
                            colocó anuncios en los periódicos donde se
                            pedían donaciones y se promovió la creación
                            de comités para recibir contribuciones de
                            dinero, libros y revistas.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/79215" target="_blank" style="color: black;">
                            <img width="100%" class="pi-10"
                            src="/assets/images/micrositio/micrositio23/BASADRE-004.jpg">
                        </a>
                        <p class="fontMS100Italic font-20 pi-10 text-right" style="font-weight: bold;">
                            <br>
                            Sala de lectura, Ca. década 1930
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            La edificación del nuevo local contó con el asesoramiento técnico de representantes de 
                            bibliotecas extrajeras. Asimismo, se consideró la implementación de las oficinas de Ingresos, 
                            Catalogación, Circulación, Consultas, además de una Sala Infantil, e incluso de un museo, 
                            donde serían debidamente conservados los incunables, códices, primeros impresos peruanos y 
                            americanos, manuscritos y toda documentación valiosa. Otros espacios considerados fueron: 
                            el Fondo General, las secciones Americana, Peruana, de Préstamo a domicilio, Infantil y 
                            de Canje y Depósito de Publicaciones Oficiales.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24">
                            Finalmente, gracias a esta labor, la Biblioteca Nacional recuperó gran parte del acervo perdido. 
                            Cuando se vuelve a abrir al público en 1947, la colección contaba con 134.000 volúmenes, 
                            un número superior a la cantidad anterior al incendio. 
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2">
                        <a href="http://hdl.handle.net/20.500.14428/79215" target="_blank" style="color: black;">
                            <img width="100%" height="70%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-005.jpg">
                        </a>
                        <p class="fontMS100Italic font-20" style="font-weight: bold;">
                            <br>
                            Depósito de libros,
                            Ca. década 1930
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <a href="http://hdl.handle.net/20.500.14428/79212" target="_blank" style="color: black;">
                            <img width="100%" height="70%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-006.jpg">
                        </a>
                        <p class="fontMS100Italic font-20" style="font-weight: bold;">
                            <br>
                            Imagen del 11 de mayo 1943,
                            posterior al desastre
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <a href="http://hdl.handle.net/20.500.14428/79213" target="_blank" style="color: black;">
                            <img width="100%" height="70%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-007.jpg">
                        </a>
                        <p class="fontMS100Italic font-20" style="font-weight: bold;">
                            <br>
                            Imagen del 11 de mayo
                            1943, posterior al desastre
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 mt-3">
                        <a href="http://revistafenix.bnp.gob.pe/index.php/fenix/article/view/163/981" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-008.jpg">
                        </a>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <a href="http://revistafenix.bnp.gob.pe/index.php/fenix/article/view/209/1067" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-010.jpg">
                        </a>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="col-sm-10 bottom_cel">
                            <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio23/BASADRE-009.jpg">
                        </div>
                        <div class="col-sm-12 c100">
                            <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio23/BASADRE-009.jpg">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-24">
                            Una de las más importantes adquisiciones que realizó Jorge Basadre cuando estuvo en la 
                            dirección de la Biblioteca Nacional fue la de la colección del general y expresidente 
                            argentino Agustín P. Justo, en 1945.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24">
                            Esta biblioteca, de más de 28 mil volúmenes, estaba conformada por obras de carácter americanista, 
                            especialmente referidas a historia, geografía, etnografía, lingüística, entre otros temas.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24">
                            Jorge Basadre, en La Biblioteca Nacional de Lima, 1943-1945, señala al respecto, que «en un país 
                            como el Perú, donde se ha exportado tantas veces e impunemente, riqueza cultural, hicimos con esta 
                            compra una auténtica y valiosa importación de esa misma riqueza. Obtuvimos no solo un grupo selecto 
                            de manuscritos, sino también una colección, considerada la más completa, de viajeros en América del Sur, 
                            obras fundamentales para la cultura antigua y actual de este continente, y no pocas joyas bibliográficas 
                            europeas también de distintas épocas. Aumentamos así de golpe en más de veinte mil volúmenes el contenido 
                            de nuestras estanterías». 
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
            </div>
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24 mt-3">
                    <br>
                    “NO POR EL NÚMERO MECÁNICO DE LIBROS, DE ESCUELAS, O DE
                    ANALFABETOS DEBEMOS JUZGAR A UN PUEBLO, SINO POR EL NÚMERO DE
                    HOMBRES Y MUJERES CONSCIENTES DE SUS MÁS ALTOS DESTINOS.
                    CONSIDEREMOS, PUES, AL LIBRO COMO UN MEDIO Y NO COMO UN FIN, A
                    LA CULTURA COMO UN PUNTO DE PARTIDA Y NO COMO UN PUNTO DE
                    LLEGADA”.
                </p>
            </div>
            <div class="col-sm-12 text-right mt-3 mb-3">
                <span class="fontMS500Italic font-24">
                    JORGE BASADRE<br>
                </span>
            </div>
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>




<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS100 text-center colorPrincipal2 font-40">
                    FUNDACIÓN DE LA ESCUELA NACIONAL
                </p>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal2 font-40">
                    DE BIBLIOTECARIOS Y EL COMIENZO DE LA
                </p>
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal2 font-40">
                            BIBLIOTECOLOGÍA EN EL PAÍS
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                </div>
                
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24 text-white">
                            BASADRE VIO EN LA RECONSTRUCCIÓN DE LA BIBLIOTECA NACIONAL UNA
                            OPORTUNIDAD PARA ERIGIR UNA MODERNA INSTITUCIÓN, PUESTA AL SERVICIO
                            DEL DESARROLLO DEL PAÍS. LA NUEVA BIBLIOTECA INCLUÍA UNA ESCUELA PARA
                            BIBLIOTECARIOS QUE SE CONCRETÓ EL 23 DE JUNIO DE 1943 MEDIANTE
                            DECRETO SUPREMO.
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24 text-white">
                            Nadie mejor que Basadre sabía del propósito de su creación. Los estudios de Bibliotecología y 
                            experiencia laboral en bibliotecas de los Estados Unidos, sumados a su trabajo en la biblioteca 
                            de la Universidad Nacional Mayor de San Marcos y en la Biblioteca Nacional, lo habían llevado 
                            al convencimiento de la necesidad de fundar una escuela de formación técnica bibliotecaria. 
                            Los egresados de esta Escuela se encargarían de conducir los destinos de la Biblioteca Nacional 
                            y de las futuras bibliotecas del país.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24 text-white">
                            La convocatoria de admisión a la Escuela se hizo público en los diarios locales. Se recibieron 305 
                            solicitudes para 25 vacantes. Basadre formó un equipo de docentes de gran categoría y amplia 
                            experiencia, incluyendo a cinco docentes del Comité Norteamericano Pro-Biblioteca de Lima. 
                            Las asignaturas elegidas para este curso fueron Administración bibliotecaria; Bibliografía, 
                            especialmente la española, americana y peruana; Clasificación y Catalogación: Historia y 
                            Técnica del Libro; Bibliotecas contemporáneas; Asociaciones Bibliotecarias y Paleografía. 
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24 text-white">
                            El primer grupo de egresados fue preparado para colaborar con la organización del material 
                            bibliográfico documental rescatado del incendio. 
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24 text-white">
                            El Departamento de Catalogación contó con la participación de Carmen Rosa Tola, Luis F. Málaga, 
                            Lucy Remy, Olivia Ojeda, María Luisa Otero, Agustina Musante y Ricardo Arbulú. 
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24 text-white">
                            En 1946, los alumnos de la Escuela Nacional de Bibliotecarios que hubiesen cursado un año de estudios 
                            más un año de prácticas profesionales en una biblioteca pública, podían ostentar el título de 
                            Auxiliar Técnico Bibliotecario. Jorge Basadre promovió que se dictaminen leyes en favor del 
                            trabajo bibliotecario, como hacer que la Escuela se encargue de la formación de profesionales 
                            de otras bibliotecas del país. 
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-011.jpg">
                    </div>
                    <div class="col-sm-12">
                        <p class="fontMS100Italic text-white font-20 text-center" style="font-weight: bold;">
                            <br>
                            Primera promoción de la Escuela de Bibliotecarios con Jorge Basadre, Ca. 1945
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-012.jpg">
                        <p class="fontMS100Italic text-white font-20 text-center" style="font-weight: bold;">
                            <br>
                            Primera promoción de la Escuela de Bibliotecarios, con Jorge Basadre, Ca. 1945
                            <br>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>


<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    EL BOLETÍN DE LA BIBLIOTECA NACIONAL,
                </p>
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            FÉNIX Y EL ANUARIO PERUANO
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
                
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24">
                            DURANTE LA DIRECCIÓN DE JORGE BASADRE SE IMPULSÓ LA PRODUCCIÓN 
                            EDITORIAL EN LA BIBLIOTECA NACIONAL. EN OCTUBRE DE 1943 SALE A LA LUZ 
                            LA PRIMERA PUBLICACIÓN, EL BOLETÍN DE LA BIBLIOTECA NACIONAL, QUE 
                            INFORMABA SOBRE LOS PLANES Y ACCIONES QUE SE DESARROLLABAN EN LA 
                            INSTITUCIÓN. EL BOLETÍN CONTIENE DECRETOS OFICIALES RELACIONADOS 
                            A LA BIBLIOTECA, INFORMACIÓN SOBRE ACTIVIDADES, AYUDA EXTRANJERA, 
                            LISTAS DE DONATIVOS EN DINERO O PUBLICACIONES, BIBLIOGRAFÍA DE 
                            MANUSCRITOS, MATERIAL SALVADO DEL INCENDIO, REGISTRO DE LA PROPIEDAD 
                            INTELECTUAL Y DE PUBLICACIONES PERIÓDICAS, ADEMÁS DE INFORMACIÓN 
                            SOBRE LA HISTORIA DE LA BIBLIOTECA NACIONAL. 
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24">
                            En el primer semestre de 1944 se publica por primera vez Fénix, revista dedicada a la bibliotecología 
                            y temas afines, y que está dirigida a académicos, bibliotecólogos y profesionales de diversas disciplinas 
                            relacionadas con los temas del libro, la lectura y las bibliotecas. La publicación era única en su género 
                            a nivel de Hispanoamérica. Tuvo un periodo de interrupción, del 2009 al 2016. Pero luego volvió a publicarse. 
                            Actualmente, la revista se encuentra disponible en formato digital. 
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" class="pd-10"
                            src="/assets/images/micrositio/micrositio23/BASADRE-013.jpg">
                        <p class="fontMS100Italic font-20" style="font-weight: bold;">
                            <br>
                            Afiche para la sensibilización pública. Ca. 1944
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-24">
                            <br><br><br>
                            En 1945 se publica el Anuario Bibliográfico Peruano, 
                            fruto del trabajo de recopilación de la producción 
                            bibliográfica nacional. Este proyecto, que iniciara 
                            el mismo Jorge Basadre cuando trabajaba en la Universidad 
                            de San Marcos, fue concluido por los bibliotecarios de la 
                            Biblioteca Nacional, a cargo de Alberto Tauro del Pino. 
                            El Anuario contiene la relación de diarios, periódicos 
                            y revistas, libros, folletos y piezas musicales que han 
                            sido producidos en el Perú o que relativos al Perú, las 
                            publicaciones periódicas aparecidas en el año y las 
                            bio-bibliografías de los peruanos eminentes fallecidos en el año respectivo. 
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/memoria-peru/j-basadre/ayuda-extranjera-a-la-biblioteca-nacional.pdf" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-014.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center font-18">
                                    Ayuda extranjera a la Biblioteca Nacional - ¿Ha contribuido usted ya a la 
                                    restauración de la Biblioteca Nacional? Boletín de la Biblioteca Nacional, 
                                    no. 6 (ene. 1945), p. 176-179.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="https://revistafenix.bnp.gob.pe/index.php/fenix/article/view/545/1411" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio23/BASADRE-015.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center font-18">
                                        La Escuela Nacional de Bibliotecarios del Perú / Nelly Mac Kee de Maurial. 
                                        Fénix, revista de la Biblioteca Nacional, no. 16 (1966), p. 243-270.
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 libro">
                        <a  target="_blank" style="color: black;">
                            <!-- <a [routerLink]="['/ficha/PLC-27']" target="_blank" style="color: black;"> -->
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-016.jpg">
                            <!-- <div class="overlay">
                                <p class="fontMS100 text-center font-18">
                                    <span class="fontMS100Italic font-18">
                                        Anuario Bibliográfico Peruano de 1943 / 
                                    </span>
                                    preparado bajo la dirección de Alberto Tauro. – Lima: Biblioteca Nacional, 1945. – p. [7] (Ediciones de la Biblioteca Nacional ; 1)
                                </p>
                            </div> -->
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>



<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            CARTAS DE JORGE BASADRE
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS100 text-center colorPrincipal font-40">
                    DEL ARCHIVO CENTRAL DE LA BNP
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24">
                            LA BIBLIOTECA NACIONAL DEL PERÚ CONSERVA EN SU ARCHIVO CENTRAL LOS DOCUMENTOS DE LA GESTIÓN DE JORGE BASADRE 
                            DEL PERIODO DE 1944 A 1948. SEGUIDAMENTE PRESENTAMOS UNA SELECCIÓN DE CARTAS DE LOS AÑOS 1944 Y 1945, LAS CUALES ESTÁN DIRIGIDAS 
                            A INVESTIGADORES, EDITORES, INTELECTUALES Y FUNCIONARIOS. ESTAS SON TESTIMONIO DE UNA GESTIÓN QUE BUSCABA MODERNIZAR 
                            Y DEMOCRATIZAR A LA BIBLIOTECA NACIONAL
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <a href="http://hdl.handle.net/20.500.14428/79214" target="_blank" style="color: black;">
                            <img width="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-017.jpg">
                            <!--<div class="overlay-img3">
                                <p class="fontMS100 text-center font-18">
                                    La Biblioteca Nacional del Perú guarda en su archivo central los documentos 
                                    de la gestión de Jorge Basadre, durante el período 1945 a 1948. Presentamos 
                                    algunas de sus cartas seleccionas de los años 1944 y 1945, dirigidas a 
                                    investigadores, editores, intelectuales y funcionarios, testimonios de una 
                                    gestión con el objetivo de convertir a la biblioteca en una institución moderna.
                                </p>
                            </div>-->
                        </a>
                    </div>
                    <div class="col-sm-12">
                        <p class="fontMS100Italic font-22 text-gris" style="font-weight: bold;">
                            <br>
                            Jorge Basadre y el librero y editor Juan Mejía Baca
                            <br><br><br>
                        </p>
                    </div>
                </div>

                <!--<div class="row">
                    <div class="col-sm-12">
                        <p>
                            <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                        </p>
                    </div>
                </div>-->
                
                <!--<div class="row mt-5">
                    <div class="col-sm-3 mt-3 libro">
                        <a [routerLink]="['/visor/CART-6366']" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-018.jpg">
                            <div class="overlay-img5">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Carta dirigida a Walter Justus<br>
                                        15 enero de 1945
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a [routerLink]="['/visor/CART-6367']" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-019.jpg">
                            <div class="overlay-img5">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Carta de Godofredo García a Jorge Basadre<br>
                                        19 enero de 1945
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a [routerLink]="['/visor/CART-6368']" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-020.jpg">
                            <div class="overlay-img5">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Carta de Jorge Basadre a Francisco Tudela<br>
                                        28 enero de 1945
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a [routerLink]="['/visor/CART-6373']" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-021.jpg">
                            <div class="overlay-img5">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Carta a Fortunato Herrera<br>
                                        29 enero de 1945                                        
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>-->

                <!--<div class="row mt-5">
                    <div class="col-sm-3 mt-3 libro">
                        <a [routerLink]="['/visor/CART-6375']" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-022.jpg">
                            <div class="overlay-img5">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Cartas de Jorge Basadre a José Antonio de Lavalle<br>
                                        30 de enero de 1945
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3">
                        <a [routerLink]="['/ficha/CART-6374']" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-023.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a [routerLink]="['/visor/CART-6376']" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-024.jpg">
                            <div class="overlay-img5">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Carta de Jorge Basadre al Gerente de la Compañía Nacional de Teléfono<br>
                                        11 enero de 1945                                       
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a [routerLink]="['/visor/CART-6377']" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio23/BASADRE-025.jpg">
                            <div class="overlay-img5">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS100">
                                        Carta de Alejandro Miró Quesada a Jorge Basadre<br>
                                        25 febrero de 1945                                        
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>-->
            </div>
        </div>

        <!--<div class="row bottom_cel mt-3">
            <div class="col libro">
                <a [routerLink]="['/visor/CART-6379']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-026.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta de Luis Alberto Sánchez a Jorge Basadre<br>
                                14 setiembre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a [routerLink]="['/visor/CART-6380']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-027.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta de Juan Mejía Baca a Jorge Basadre<br>
                                16 octubre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a [routerLink]="['/visor/CART-6382']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-028.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta dirigida a Guillermo Lohmann 1/2<br>
                                23 noviembre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a [routerLink]="['/visor/CART-6382']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-029.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta dirigida a Guillermo Lohmann 2/2<br>
                                23 noviembre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a [routerLink]="['/visor/CART-6383']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-030.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta dirigida a José G. Cosio<br>
                                11 diciembre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>-->
        <!--RESPONSIVE-->
        <!--<div class="row c100">
            <div class="col-sm-2 libro mt-3">
                <a [routerLink]="['/visor/CART-6379']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-026.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta de Luis Alberto Sánchez a Jorge Basadre<br>
                                14 setiembre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a [routerLink]="['/visor/CART-6380']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-027.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta de Juan Mejía Baca a Jorge Basadre<br>
                                16 octubre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a [routerLink]="['/visor/CART-6382']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-028.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta dirigida a Guillermo Lohmann 1/2<br>
                                23 noviembre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a [routerLink]="['/visor/CART-6382']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-029.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta dirigida a Guillermo Lohmann 2/2<br>
                                23 noviembre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a [routerLink]="['/visor/CART-6383']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio23/BASADRE-030.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100">
                                Carta dirigida a José G. Cosio<br>
                                11 diciembre de 1944
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>-->
    </div>
    <!--CARROUSEL-->
    <div class="w-90 text-center ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                <div class="divLibros text-center w-100">
                    <a style="color: inherit;" href="{{slide.id}}" target="_blank">
                        <p class="text-center">
                            <img src="{{ slide.img }}" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span class="fontMS500">{{slide.autor}}</span><br>
                                <span class="fontMS100">{{slide.anuNacimiento}}</span><br>
                                <span class="fontMS100">{{slide.anno}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
</div>


<div class="container_Morado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="row mt-4">
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Cómo son las bibliotecas en la actualidad? ¿Consideras que son importantes? ¿Por qué?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Existe relación entre las bibliotecas e internet?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Cuáles crees que son las tareas que desempeña un bibliotecólogo en la actualidad? 
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <p class="font-24 text-gris">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Basadre, J. (1975)</span><br>
                    <span class="fontMS100Italic text-gris">
                        Recuerdos de un bibliotecario peruano:
                        1919-1930; 1930-1932; 1935-1942;
                        1943-1948; 1956-1958. <br>
                    </span>
                    <span class="text-gris">
                        Lima: Edit. Historia<br>
                    </span>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/recuerdos-de-un-bibliotecario-peruano/" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Basadre, J. (2004)<br>
                    </span>
                    <span class="fontMS100Italic text-gris">
                        Reconstructor de la Biblioteca Nacional del
                        Perú.<br>
                    </span>
                    <span class="text-gris">Lima: Biblioteca Nacional del Perú<br></span>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/fondo-editorial/FE_017/files/assets/basic-html/page-3.html" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Gonzales, O. (2001)<br></span>
                    <span class="fontMS100Italic text-gris">
                        Algunas Cartas de Jorge Basadre. FENIX,
                        (43-44), 101-128<br>
                    </span>
                    <a href="http://revistafenix.bnp.gob.pe/index.php/fenix/article/view/50/1195"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Libros & Artes N°3<br></span>
                    <span class="fontMS100Italic text-gris">
                        Revista de cultura de la Biblioteca Nacional
                        del Perú, 2002<br>
                    </span>
                    <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/flippingbook/librosyartes_bnp_003/files/assets/basic-html/page-3.html"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Sobrevilla, D. (2004).<br>
                    </span>
                    <span class="fontMS100Italic text-gris">
                        Basadre, ese desconocido: estudios y
                        bibliografía basadrianos.<br>
                    </span>
                    <span class="text-gris">Lima: Universidad Ricardo Palma<br></span>
                    <a href="http://info.bnp.gob.pe/cgi-bin/abnopac/O8965/IDdd5ecbbb/NT1" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Mackee de Maurial, N. (1966)<br></span>
                    <span class="fontMS100Italic text-gris">La Escuela Nacional de Bibliotecarios del
                        Perú.<br>
                    </span>
                    <span class="text-gris">
                        FENIX, (16), 243-270.<br>
                    </span>
                    <a href="http://revistafenix.bnp.gob.pe/index.php/fenix/article/view/545/1411"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->